import List from '../../pages/Blog/Tutorials/List';
import Detail from '../../pages/Blog/Tutorials/Detail';
import Create from '../../pages/Blog/Tutorials/Create';

export const subRoutesTutorials = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/tutorials${item.path}`,
        private: true
    };
});

export const routesTutorials = [
    {
        path: "/create",
        component: Create,
        exact: true
    },
    {
        path: "/:elementId",
        component: Detail,
    }
].map((item) => {
    return {
        ...item,
        path: `/tutorials${item.path}`,
        private: true
    };
});